
export type CompanyStatus = 'active' | 'suspended';
export type CompanyType = 'BORROWER' | 'SUPPLIER';

/**
 * Company interface fetched from the API
 */
export interface CompanyInterface {
    /** The company ID */
    companyId: number;

    /** NLS cifno */
    cifno: number;

    companyType: 'SUPPLIER' | 'BORROWER';

    companyName: string;

    companyStatus: CompanyStatus;
}

/**
 * Company represents a company for the user
 */
export class Company {
    /** Attribute fields */
    private _companyId: number;
    private _cifno: number;
    private _companyType: CompanyType;
    private _companyStatus: CompanyStatus;
    private _companyName: string;

    /**
     * Construct a generic company entry
     * 
     * @param id The id of the company
     * @param companyId The id of the company
     * @param companyType The type of the company
     */
    constructor(companyId: number, cifno: number, companyType: CompanyType, companyName: string, companyStatus: CompanyStatus) {
        this._companyId = companyId;
        this._cifno = cifno;
        this._companyType = companyType;
        this._companyName = companyName;
        this._companyStatus = companyStatus;
    }

    /** Getters */
    public get companyId(): number {
        return this._companyId;
    }

    public get cifno(): number {
        return this._cifno;
    }

    public get companyType(): CompanyType {
        return this._companyType;
    }

    public get companyName(): string {
        return this._companyName;
    }

    public get companyStatus(): CompanyStatus {
        return this._companyStatus;
    }

    /** Setters */
    public set companyId(companyId: number) {
        this._companyId = companyId
    }

    public set cifno(cifno: number) {
        this._cifno = cifno;
    }

    public set companyType(companyType: CompanyType) {
        this._companyType = companyType;
    }

    public set companyName(name: string) {
        this._companyName = name;
    }

    public set companyStatus(status: CompanyStatus) {
        this._companyStatus = status;
    }
}

/**
 * CompanyMapper to map between interface and model
 */
export class CompanyMapper {
    /**
     * Map a company interface to a company model
     */
    static toModel(dto: CompanyInterface): Company {
        return new Company(
            dto.companyId,
            dto.cifno,
            dto.companyType,
            dto.companyName,
            dto.companyStatus
        );
    }

    /**
     * Map a company model to a company interface
     */
    static toDto(model: Company): CompanyInterface {
        return {
            companyId: model.companyId,
            cifno: model.cifno,
            companyType: model.companyType,
            companyName: model.companyName,
            companyStatus: model.companyStatus
        };
    }
}